export default "__VITE_ASSET__Ds_RqaCZ__"